/**
 * Import
 * - Libraries
 */
import { connect } from 'react-redux'

import { forgotTrigger } from '../../../actions'
/**
 * Import
 * - Store
 */
import { RootState } from '../../../store'

/**
 * Import
 * - Actions
 */
import { saveAccountChanges } from '../../../actions'
import { fetchUserDetail } from '../../../actions'
/**
 * Import
 * - Selectors
 */
import { getAppLoading } from '../../../selectors/app'

/**
 * Import
 * - Component Logout
 */
import UserAccount from '../../../components/pages/UserAccount/UserAccount'

const mapStateToProps = (state: RootState) => {
    return {
        loading: getAppLoading(state),
        errorState: state.users.users.error,
        userDetail: state.userDetail,
    }
}

export default connect(mapStateToProps, {
    saveAccountChangesTrigger: saveAccountChanges,
    fetchUserDetail: fetchUserDetail,
    forgotTrigger: forgotTrigger,
}
)(UserAccount)



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/containers/pages/UserAccount/UserAccount.tsx